export enum IntegrationFlow {
  DIRECTLY = 0,
  THIRD_API = 1,
  SEND_EMAIL_CONFIRMATION = 2
}
